import api from "../lib/axios";

const BASE_URL = "/Project";

export const projectService = {
  getPublishedAsync: async () => {
    const response = await api.get(`${BASE_URL}/get-published`);
    return response.data;
  },
  getBySlugAsync: async (slug) => {
    const response = await api.get(`${BASE_URL}/get-by-slug/${slug}`);
    return response.data;
  },
  getByClientAsync: async (clientId) => {
    const response = await api.get(`${BASE_URL}/get-by-client/${clientId}`);
    return response.data;
  },
};
